//@flow
import React from 'react';
import { Icon, Button, Tooltip, Flex } from '@locus-taxy/neo-ui';
import type { TFunction } from 'react-i18next';
import coreIds from 'common/tests/core/coreIds.json';

type Props = {
    t: TFunction
};

const FeedbackButton = ({ t }: Props) => (
    <Tooltip tooltip={t('translations:giveFeedback')}>
        <Button data-test-id={coreIds.feedbackBtn} appearance="outline">
            <Flex alignItems="center">
                <Icon icon="feedback" />
            </Flex>
        </Button>
    </Tooltip>
);

export default FeedbackButton;
